import ActionType from '../actions/ActionType'

export default (
  state = {
    modalOpen: false,
    acknowledgementText: '',
    contactMethod: '',
    messageType: '',
    acknowledgedMethods: {},
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Acknowledgements.CREATE_SUCCESS:
      return {
        modalOpen: false,
        acknowledgementText: '',
        contactMethod: '',
        messageType: '',
        acknowledgedMethods: { ...state.acknowledged, [action.contact_method]: true },
      }
    case ActionType.Acknowledgements.TOGGLE_MODAL:
      return {
        ...state,
        modalOpen:
          action.payload && typeof action.payload.modalOpen === 'boolean'
            ? action.payload.modalOpen
            : !state.modalOpen,
        acknowledgementText:
          action.payload && action.payload.acknowledgementText
            ? action.payload.acknowledgementText
            : '',
        contactMethod:
          action.payload && action.payload.contactMethod
            ? action.payload.contactMethod
            : '',
        messageType:
          action.payload && action.payload.messageType
            ? action.payload.messageType
            : '',
      }
    default:
      return state
  }
}
